module.exports = "/images/favicon.jpg";